(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videeo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var track = section.querySelector('[data-wb-track]');
      if (!track) return;

      var prev = section.querySelector('[data-wb-prev]');
      var next = section.querySelector('[data-wb-next]');
      function step() {
        var card = track.querySelector('.wb-card');
        return card ? card.getBoundingClientRect().width + 22 : 300;
      }
      function syncNav() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', syncNav, { passive: true });
      syncNav();

      var hoverAutoplay = section.getAttribute('data-autoplay') === 'true';

      function pauseAllExcept(except) {
        section.querySelectorAll('[data-wb-video]').forEach(function (v) {
          if (v !== except) { v.pause(); var m = v.closest('[data-wb-media]'); if (m) m.classList.remove('is-playing'); }
        });
      }

      section.querySelectorAll('[data-wb-play]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var media = btn.closest('[data-wb-media]');
          var video = media.querySelector('[data-wb-video]');
          if (!video) return;
          if (video.paused) { pauseAllExcept(video); video.play(); media.classList.add('is-playing'); }
          else { video.pause(); media.classList.remove('is-playing'); }
        });
      });

      if (hoverAutoplay) {
        section.querySelectorAll('[data-wb-media]').forEach(function (media) {
          var video = media.querySelector('[data-wb-video]');
          if (!video) return;
          media.addEventListener('mouseenter', function () { pauseAllExcept(video); video.play().then(function(){ media.classList.add('is-playing'); }).catch(function(){}); });
          media.addEventListener('mouseleave', function () { video.pause(); video.currentTime = 0; media.classList.remove('is-playing'); });
        });
      }

      section.querySelectorAll('[data-wb-add]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch) return;
          e.preventDefault();
          var btn = form.querySelector('.wb-card__atc');
          var label = btn ? btn.textContent : '';
          if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
            body: new URLSearchParams(new FormData(form))
          })
            .then(function (r) { return r.json(); })
            .then(function () {
              if (btn) btn.textContent = 'Added ✓';
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              document.dispatchEvent(new CustomEvent('cart:build'));
              if (typeof window.fetch === 'function') { fetch(root + '?section_id=cart-drawer'); }
              setTimeout(function () { if (btn) { btn.textContent = label; btn.disabled = false; } }, 1600);
            })
            .catch(function () { form.submit(); });
        });
      });
    }

    document.querySelectorAll('[data-wb]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('[data-wb]');
      if (s) init(s);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
